import { useParams, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { publicApiClient } from '@/api/public'
import { moneyFor } from '@/lib/money'
import { datesFor } from '@/lib/dates'
import { useEmbedResize } from '@/hooks/useEmbedResize'
import CourseDetail from './CourseDetail'
import { cleanColour, embedAccentVars } from './brand'

/** One course as it appears inside a customer's iframe: pictures, content and dates, no page chrome. colour=#rrggbb sets the accent. */
export default function EmbedCoursePage() {
  const { slug, courseSlug } = useParams<{ slug: string; courseSlug: string }>()
  const [params] = useSearchParams()
  const frame = useEmbedResize()
  const colour = cleanColour(params.get('colour') ?? params.get('primaryColour'))

  const { data, isLoading, isError } = useQuery({
    queryKey: ['public-course', slug, courseSlug],
    queryFn: () => publicApiClient.getPublicCoursePage(slug!, courseSlug!).then(r => r.data),
    enabled: !!slug && !!courseSlug,
  })
  const { fmt: fmtMoney } = moneyFor(data?.currency)
  const { formatDate, formatTime } = datesFor(data?.region, data?.timeZoneId)

  return (
    <div ref={frame} className="flow-root p-1 font-sans" style={embedAccentVars(data ?? { primaryColour: null, secondaryColour: null }, colour)}>
      {isLoading && (
        <div className="flex justify-center p-8">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-[var(--brand-accent)] border-t-transparent" />
        </div>
      )}
      {!isLoading && (isError || !data) && <p className="p-8 text-center text-sm text-slate-400">This course is unavailable.</p>}
      {data && <CourseDetail embed data={data} slug={slug!} fmtMoney={fmtMoney} formatDate={formatDate} formatTime={formatTime} />}
    </div>
  )
}
